import { render, staticRenderFns } from "./ProgrammeSubject.vue?vue&type=template&id=6404c68f"
import script from "./ProgrammeSubject.vue?vue&type=script&lang=js"
export * from "./ProgrammeSubject.vue?vue&type=script&lang=js"
import style0 from "./ProgrammeSubject.vue?vue&type=style&index=0&id=6404c68f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports